import { Colors, Lightning, Utils } from '@lightningjs/sdk'
import { cleanHtml, formatDate, formatTimeHoursOrMinutes, daysLeft } from '../../lib/AppHelpers'

export default class PodcastEpisodeItem extends Lightning.Component {
  static _template() {
    return {
      w: 800,
      h: 195,
      InfoWrapper: {
        w: w => w,
        y: 0,
        Title: {
          w: w => w,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('title'),
            fontSize: 28,
            lineHeight: 36,
            fontFace: 'OpenSansRegular',
            wordWrapWidth: 700,
            maxLines: 2,
            textOverflow: 'ellipsis',
          },
        },
        DescrText: {
          w: w => w,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('descrText'),
            fontSize: 22,
            fontFace: 'OpenSansRegular',
            lineHeight: 32,
            wordWrapWidth: 700,
            maxLines: 1,
            textOverflow: 'ellipsis',
          },
        },
        DateLength: {
          w: w => w,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('dateLength'),
            lineHeight: 35,
            fontSize: 22,
            fontFace: 'OpenSansRegular',
          },
        },
      },
      PlayIcon: {
        x: 730,
        y: 150,
        w: 70,
        h: 70,
        alpha: 0.001,
        src: Utils.asset('/images/playerbuttons/playButton100f.png'),
      },
      BottomLine: {
        w: 800,
        h: 2,
        y: 190,
        rect: true,
        color: Colors('white').get(),
      },
    }
  }

  set item(itm) {
    this._item = itm
  }

  get item() {
    return this._item
  }
  set bgImage(v) {
    this._itemBg = v
  }

  _init() {
    this._expanded = false

    this.tag('Title').on('txLoaded', () => {
      this.tag('DescrText').y = this.tag('Title').y + this.tag('Title').finalH + 8
    })

    this.tag('DescrText').on('txLoaded', () => {
      this.tag('DateLength').y = this.tag('DescrText').y + this.tag('DescrText').finalH
    })
  }

  _firstActive() {
    this._update()
  }

  set albumImage(img) {
    this._albumImage = img
  }

  _update() {
    let title = this._itemBg
        ? formatDate(new Date(this._item.startDate), PodcastEpisodeItem.LONG_DATE_FORMAT)
        : this._item.title,
      descrText = cleanHtml(this._item.description),
      until = new Date(this._item.availableUntil ? this._item.availableUntil : this._item.pubDate) // calculating available period to listen episode

    let dateLength = ''
    if (this._item && this._item.duration) {
      const dur = this._item.duration.split(':')
      until = this._itemBg
        ? `${daysLeft(until)} days left`
        : formatDate(until, PodcastEpisodeItem.SHORT_DATE_FORMAT)

      const seconds = dur[0] * 3600 + dur[1] * 60 + +dur[2]
      dateLength = this._itemBg
        ? `${formatTimeHoursOrMinutes(seconds)}  ${until}`
        : `${until}  ${formatTimeHoursOrMinutes(seconds)}`
    }
    this.patch({
      title,
      descrText,
      dateLength,
    })
  }

  _showLargeSmall(expanded) {
    this._expanded = expanded

    const itemWidth = expanded === true ? 800 : 800
    const itemHeight = expanded === true ? 240 : 195
    const infoWrapperWidth = expanded === true ? 700 : 700
    const descriptionMaxLines = expanded === true ? 2 : 1
    const bottomLineHeight = expanded === true ? 3 : 2
    const bottomLineY = expanded === true ? 235 : 190
    const textFontFace = expanded === true ? 'OpenSansBold' : 'OpenSansRegular'
    const textFontStyle = expanded === true ? 32 : 28
    const playIconY = expanded === true ? 150 : 105
    const playIconAlpha = expanded === true ? 1 : 0

    this.patch({
      w: itemWidth,
      h: itemHeight,
      InfoWrapper: {
        smooth: {
          w: [infoWrapperWidth, PodcastEpisodeItem.TRANSITION],
        },
        Title: {
          text: {
            fontFace: textFontFace,
            fontSize: textFontStyle,
          },
        },
        DescrText: {
          text: { maxLines: descriptionMaxLines },
        },
      },
      PlayIcon: {
        smooth: {
          alpha: [playIconAlpha, PodcastEpisodeItem.TRANSITION],
          y: [playIconY, PodcastEpisodeItem.TRANSITION],
        },
      },
      BottomLine: {
        smooth: {
          w: [itemWidth, PodcastEpisodeItem.TRANSITION],
          h: [bottomLineHeight, PodcastEpisodeItem.TRANSITION],
          y: [bottomLineY, PodcastEpisodeItem.TRANSITION],
        },
      },
    })
  }

  _focus() {
    this._showLargeSmall(true)
  }

  _unfocus() {
    this._showLargeSmall(false)
  }

  get cellSizes() {
    return this.sizes
  }
}
PodcastEpisodeItem.LONG_DATE_FORMAT = {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
}
PodcastEpisodeItem.SHORT_DATE_FORMAT = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
}
PodcastEpisodeItem.TRANSITION = { duration: 0.3, delay: 0, timingFunction: 'ease-in' }
